<template>
  <div>
    <Navbar v-show="routemeta.navbar" />
    <Breadcrumb
      :breadcrumbOverride="breadcrumbOverride"
      v-show="routemeta.navbar"
    />
    <div class="container-xl">
      <div v-if="elearningstep" class="border-0 text-container-wider">
        <div class="mb-3">
          <h2 class="text-primary">
            {{ elearningstep ? elearningstep.step_name : '' }}
          </h2>
        </div>
        <div class="mx-0 px-0 col-12">
          <div class="row mx-0 px-0">
            <div class="mx-0 px-0 col-12 col-lg-7">
              <span v-html="elearningstep ? elearningstep.step_introduction : ''"></span>
            </div>
            <div class="mx-0 px-0 col-12 col-lg-5 text-end text-top">
              <a
                class="btn btn-outline-secondary me-2"
                :href="`/elearningmodule/${elearningstep ? elearningstep.module_id : 0 }`"
              >
                Back
              </a>
              <button type="button" class="btn btn-primary">Contact your tutor</button>
            </div>
          </div>
          <div v-if="elearningstep && elearningstep.step_videolink !== ''">
            <h3
              class="pt-4 mt-4"
              style="border-top: 1px solid black"
            >
              Video
            </h3>
            <div
              v-if="vid"
              style="padding:56.25% 0 0 0;position:relative;"
            >
              <iframe
                :src="`https://player.vimeo.com/video/${vid}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                style="position:absolute;top:0;left:0;width:100%;height:100%;"
                :title="`${elearningstep ? elearningstep.step_name : ''}`">
              </iframe>
            </div>
          </div>
          <div>
            <h3
              class="pt-4 mt-4"
              style="border-top: 1px solid black"
            >
              Notes
            </h3>
            <div class="row mx-1">
              <textarea
                v-model="step_note"
                placeholder="Enter your notes here"
                rows="3"
                class="form-control col-12 mb-2"
              ></textarea>
            </div>
            <a
              class="ms-1"
              href="#"
              @change="noteDirty = true"
              @click.prevent="stepnotes_save"
            >
              Save note
              <div
                v-if="dismissCountDown"
                class="alert alert-success d-inline-flex py-1 px-2 ms-2 mb-0 align-items-center"
                role="alert"
              >
                <span class="text-white">Note saved</span>
              </div>
            </a>
          </div>
          <div class="accordion" v-if="elearningstep && elearningstep.step_description !== ''" role="tablist">
            <div class="card mb-1">
              <div class="card-header p-1" role="tab">
                <button class="btn btn-info w-100 text-start" type="button" @click="scriptOpen = !scriptOpen">
                  Script
                </button>
              </div>
              <div class="collapse" :class="{ show: scriptOpen }">
                <div class="card-body">
                  <span v-html="elearningstep ? elearningstep.step_description : ''"></span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row mx-1 pb-4 mb-4"
          >
            <div class="col-6 ps-0">
              <button
                v-if="step_number > 0"
                class="btn btn-secondary"
                @click.prevent="prevpage"
              >
                &lt; Back
              </button>
            </div>
            <div class="col-6 text-end pe-0">
              <button
                v-if="step_number < steps.length - 1"
                class="btn btn-primary"
                @click.prevent="nextpage"
              >
                Next &gt;
              </button>
              <button
                v-if="step_number >= steps.length - 1"
                class="btn btn-primary"
                @click.prevent="donemodule"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'

export default {
    name: 'LearningStep',
    components: {
      Navbar,
      Breadcrumb,
    },
    data() {
      return {
        routemeta: this.$route.meta,
        breadcrumbOverride: [],
        consultant_id: this.$store.state.user_id,
        step_id: this.$route.params.s ? this.$route.params.s : 0,
        steps: [],
        course_id: null,
        module_id: null,
        elearningcourse: null,
        elearningmodule: null,
        elearningstep: undefined,
        vtoken: null,
        vid: null,
        note_id: 0,
        step_note: '',
        noteDirty: false,
        savingNote: false,
        savedNote: false,
        dismissSecs: 2,
        dismissCountDown: 0,
        scriptOpen: false
      }
    },
    created() {
      this.init();
    },
    computed: {
      step_number() {
        return this.steps.map(function(e) { return e.id; }).indexOf(this.elearningstep ? this.elearningstep.id : 1);
      }
    },
    watch: {
      '$route.path': function() { this.init(); },
      elearningstep: function() {}
    },
    methods: {
      init() {
        this.$store.dispatch('record_read', { table_name: 'g_elearning_steps', id: this.step_id })
        .then((resp) => {
          this.elearningstep = resp.data;
          this.module_id = resp.data.module_id;
          this.module_get();
          if (this.elearningstep.step_videolink) {
            this.vid = null;
            this.vid = this.elearningstep.step_videolink;
          } else {
            this.vid = null;
          }
          this.stepnotes_get();
          this.steps_get();
          this.$store.dispatch('elearningstep_update', { step_id: this.step_id });
        })
      },
      course_get() {
        this.$store.dispatch('record_read', { table_name: 'g_elearning_courses', id: this.course_id })
        .then((resp) => {
            this.elearningcourse = resp.data;
            this.breadcrumbOverride =  [
              { to: '/', text: 'My GDQ Management' },
              { to: '/learninghub', text: 'Learning Hub' },
              { to: `/elearningcourse/${this.elearningcourse.id}/0`, text: `${this.elearningcourse.course_name}` },
              { to: `/elearningmodule/${this.elearningmodule.id}`, text: `${this.elearningmodule.module_name}` },
              { to: '/', text: this.elearningstep.step_name }
            ];
        })
      },
      module_get() {
        this.$store.dispatch('record_read', { table_name: 'g_elearning_modules', id: this.module_id })
        .then((resp) => {
          this.elearningmodule = resp.data;
          this.course_id = resp.data.course_id;
          this.course_get();
          this.steps_get();
        })
      },
      stepnotes_get() {
        const filter = {
          consultant_id: {
            operator: '=',
            value: this.consultant_id,
          },
          step_id : {
            operator: '=',
            value: this.step_id,
          }
        }
        this.$store.dispatch('records_readall', { table_name: 'g_elearning_consultant_notes', filter})
        .then((resp) => {
          if (resp.data.total > "0") {
            const note = resp.data.result[0];
            this.note_id = note.id
            this.step_note = note.step_note;
          } else {
            this.note_id = 0;
            this.step_note = '';
          }
        })
      },
      stepnotes_save() {
        // eslint-disable-next-line
        this.savingNote = true;
        const rec = {
          consultant_id: this.consultant_id,
          step_id: this.step_id,
          step_note: this.step_note,
        }
        if (this.note_id === 0) {
          this.$store.dispatch('record_post',{ table_name: 'g_elearning_consultant_notes', record: rec })
          .then(res => this.note_id = res.data.id );
          this.savedNote = true;
          this.noteDirty = false;
          this.savingNote = false;
          this.dismissCountDown = this.dismissSecs
          setTimeout(() => { this.dismissCountDown = 0 }, this.dismissSecs * 1000)
        } else {
          this.$store.dispatch('record_put', { table_name: 'g_elearning_consultant_notes', id: this.note_id, record: rec });
          this.savedNote = true;
          this.noteDirty = false;
          this.savingNote = false;
          this.dismissCountDown = this.dismissSecs
          setTimeout(() => { this.dismissCountDown = 0 }, this.dismissSecs * 1000)
        }
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      steps_get() {
        const filter = {
          module_id: {
            operator: '=',
            value: this.module_id,
          }
        };
        this.$store.dispatch('record_readlist', { table_name: 'g_elearning_steps', filter, orderby: 'step_number'})
        .then((resp) => {
          this.steps = resp.data.result;
        })
      },
      prevpage() {
        let index = this.steps.map(function(e) { return e.id; }).indexOf(this.elearningstep.id);
        index--;
        if (index > -1) {
          this.$router.push({ path: '/elearningstep/'+this.steps[index].id })
          this.step_id = this.steps[index].id;
          this.init();
        }
      },
      nextpage() {
        let index = this.steps.map(function(e) { return e.id; }).indexOf(this.elearningstep.id);
        index++;
        if (index < this.steps.length) {
          this.$router.push({ path: '/elearningstep/'+this.steps[index].id })
          this.step_id = this.steps[index].id;
          this.init();
        }
      },
      donemodule() {
        const link = '/elearningcourse/'+this.course_id;
        this.$router.push({ path: link })
      },
      goback() {
        const link = '/elearningmodule/'+this.elearningstep.module_id;
        this.$router.push({ path: link })
      },
      gohome() {
        this.$router.push({ path: '/learninghub' })
      },
    }
}
</script>
<style scoped>

</style>
